import React from "react";
import { CiCirclePlus } from "react-icons/ci";
import { CiCircleMinus } from "react-icons/ci";

const CustomRoomSelect = ({ Room, setRoom }) => {
  const handleAddRow = () => {
    setRoom([
      ...Room,
      {
        room: Room.length + 1,
        adult: 2,
        children: 0,
      },
    ]);
  };

  const handleRemove = (selectedItem) => {
    let updatedRooms;

    if (Room.length > 1) {
      updatedRooms = Room.filter((r) => r.room !== selectedItem.room);
    } else {
      updatedRooms = [{ room: 1, adult: 2, children: 0 }];
    }

    const reindexed = updatedRooms.map((r, index) => ({
      ...r,
      room: index + 1,
    }));

    setRoom(reindexed);
  };
  const handlePlusAdult = (selectedItem) => {
    const updatedRooms = Room.map((r) => {
      if (r.room === selectedItem.room) {
        return { ...r, adult: r.adult + 1 };
      }
      return r;
    });
    setRoom(updatedRooms);
  };
  const handleMinusAdult = (selectedItem) => {
    const updatedRooms = Room.map((r) => {
      if (r.room === selectedItem.room && r.adult > 1) {
        return { ...r, adult: r.adult - 1 };
      }
      return r;
    });
    setRoom(updatedRooms);
  };
  const handlePlusChildren = (selectedItem) => {
    const updatedRooms = Room.map((r) => {
      if (r.room === selectedItem.room) {
        return { ...r, children: r.children + 1 };
      }
      return r;
    });
    setRoom(updatedRooms);
  };
  const handleMinusChildren = (selectedItem) => {
    const updatedRooms = Room.map((r) => {
      if (r.room === selectedItem.room && r.children > 0) {
        return { ...r, children: r.children - 1 };
      }
      return r;
    });
    setRoom(updatedRooms);
  };

  return (
    <div className="w-[220px] lg:w-[450px] border rounded-lg bg-white drop-shadow-md overflow-hidden">
      {Room.map((item, index) => {
        return (
          <div key={index} className="w-full space-y-2  py-3">
            <div className="flex justify-between items-center px-4 pt-3">
              <p className="font-bold text-[#2155ad]">Room</p>
              <div className="flex items-center gap-x-2">
                {item.room > 1 && (
                  <button onClick={() => handleRemove(item)}>
                    <p className="text-xs text-[#2155ad]">remove</p>
                  </button>
                )}
              </div>
            </div>
            <div className="flex justify-between items-center px-4 ">
              <div>
                <p className="text-[#2155ad] text-sm font-semibold">Adults</p>
                <p className="text-black/50 text-[11px]">10 years +</p>
              </div>
              <div className="flex justify-start items-center gap-x-2">
                <button onClick={() => handleMinusAdult(item)}>
                  <CiCircleMinus size={25} className="text-black/50" />
                </button>
                <div>
                  <p>{item.adult}</p>
                </div>
                <button onClick={() => handlePlusAdult(item)}>
                  <CiCirclePlus size={25} className="text-black/50" />
                </button>
              </div>
            </div>
            <div className="flex justify-between items-center px-4 ">
              <div>
                <p className="text-[#2155ad] text-sm font-semibold">
                  {item.children > 1 ? "Childrens" : "Child"}
                </p>
                <p className="text-black/50 text-[11px]">0 - 10 years</p>
              </div>
              <div className="flex justify-start items-center gap-x-2">
                <button onClick={() => handleMinusChildren(item)}>
                  <CiCircleMinus size={25} className="text-black/50" />
                </button>
                <div>
                  <p>{item.children}</p>
                </div>
                <button onClick={() => handlePlusChildren(item)}>
                  <CiCirclePlus size={25} className="text-black/50" />
                </button>
              </div>
            </div>
          </div>
        );
      })}
      {/* <div className="pt-3">
        <button
          onClick={handleAddRow}
          className="bg-[#0b2e6b] text-white uppercase w-full text-xs py-2"
        >
          Add Room
        </button>
      </div> */}
    </div>
  );
};

export default CustomRoomSelect;
